import { cx } from '@libs/classnames';
import { StarIcon } from '@ui/icons/StarIcon';

import styles from './StarsFigure.module.css';

// Тройка звезд с заполнением по порогу — очки за решение, как в листе ходов.
// Цвета настраиваются через --star-icon-color-full / -empty / -outline
export function StarsFigure({
  className,
  value,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
  value: number;
}) {
  return (
    <figure className={cx(styles.stars, className)} onClick={onClick}>
      <StarIcon filled={value >= 3} />
      <StarIcon filled={value >= 2} />
      <StarIcon filled={value >= 1} />
    </figure>
  );
}
